<template>
  <div class="app-pager" v-if="pager.pageCount > 1">
    <b-card-body class="pt-0 pb-3">
      <div class="row">
        <div class="col-sm text-sm-left text-center pt-3">
          <span class="text-muted">Page {{ pager.currentPage }} of {{ pager.pageCount }}</span>
        </div>
        <div class="col-sm pt-3">
          <b-pagination
            class="justify-content-center justify-content-sm-end m-0"
            :value="pager.currentPage"
            :total-rows="pager.totalCount"
            :per-page="pager.perPage"
            @change="change"
            size="sm"
          />
        </div>
      </div>
    </b-card-body>
  </div>
</template>

<script>
export default {
  name: 'app-pager',
  props: {
    pager: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    change(pageNum) {
      this.$emit('change', pageNum)
    }
  }
}
</script>

<style scoped lang="scss"></style>
